import React from 'react';
import styles from './index.module.scss';
export default function Clause() {
  return (
    <div className={styles.clause}>
      <p className={styles.title}>成都音线网络科技有限公司《服务条款》</p>
      <img src={require('./image/1.png').default} />
      <img src={require('./image/2.png').default} />
      <p className={styles.two}>
        <p className={styles.msg}>1.3</p>
        <p className={styles.msg}>
          手橙鹰用程式︰按一下用卢介面右下方的[帐币]暹项﹐登入后可于[盯开组合]内查看
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>1.4</p>
        <p className={styles.msg}>
          平板鼋淌鹰用程式∶按一下用巨介面右下方的[帐户]暹项﹐登入后可于[盯开组合]内查看
        </p>
      </p>
      <p className={styles.one}>2. 免费试用</p>
      <p className={styles.two}>
        <p className={styles.msg}>2.1</p>
        <p className={styles.msg}>
          您的正念畲员资格可以先緃免费轼用开始·畲晨瓷格免费轼用期票鲑册踌指定日期或另行规定期限﹐其目的是镶新畲员和某些前畲具封用服鸦
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>2.2</p>
        <p className={styles.msg}>
          免费封用期资格由正念全榷酌情泱定﹐我阴可能畲限制资格﹐以避免婺生免费眦用蓄用的情况·我阴保留取淌免费轼用期资格之榷利﹐如果我咐眩定您不符镝用资格踌﹐将詹暂停您的幅卢·具倩琨有或最近刚取得正念畲具资格的畲具不符合资格·我阴可能鲁使用奘置藏别碣·付款方式或目前或最近刚取得正念畲员资格的帐卢所使用的鼋鄄地址的资惑﹐来碓定是否具借资格Р舆其他慑惠一起使用畴可能畲有限制规定·
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>2.3</p>
        <p className={styles.msg}>
          免费试用期结束后﹐除非闇下缮缭钉瞒﹐否则不向您收取任何收费.
        </p>
      </p>
      <p className={styles.one}>3. 收费</p>
      <p className={styles.two}>
        <p className={styles.msg}>3.1</p>
        <p className={styles.msg}>
          收费遗期·ATⅣ盯髑组合畲具费及针剿您使用本服矜可能奎生的任何其他费用﹐例如税金典可能的交易手縯费﹐将舍按月封愿您畲晨资格开始付款部分的日期﹔依照您的付款方式向您收取·在某些情况下﹔您的付款日可能鲁缵勤﹐例如﹐您的付款方式血未结算成功﹐或您的付费含晨资格敞用日期在某固月份没有勤愿日期·前往您的[盯开组合](方法睛参开本服矜倏款第1倏)﹐即可查看您的下一付款日期·
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>3.2</p>
        <p className={styles.msg}>
          付款方式·如果由于遗期·资金不足或其他原因樽致付款失敢﹐且您没有更改付款方式或取淌幔币﹐则我阴可暂停您封服矜的使用﹐直至我阴取得有效的付款方式·凿您更新付款方式赔﹐您即授榷我胭以更新后的付款方式继缜向您收费﹐且您仍须蒍任何未收取的金额负责·此情况可能造成您的付款日期爱更·针到某些付款方式﹔豉行檄媾可能舍向您收取特定费用﹐例如跨国交易手縯费或其他针到您的付款方式之虚理所收取的黄用·尝地税额可能因所使用的付款方式而有所不同·群情o豁韵您的付款方式服移提供者
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>3.3</p>
        <p className={styles.msg}>
          取淌盯髑组合自员·您可随膊取消您的正念钉开组合畲具资格﹐在眷月收费插期结束前﹐可僊绩使用本服移·在相闟法律斯可之i圈内﹐付款不可退款﹐且到于不足一但月的合晨期或未都赏的ATⅣ内容，我膺不予退款或抵用·付费畲具于收费逶期结束或停止付款后﹐其盯开组合畲晨资格将畲被更改蒍免费畲员·睛先了解您曾粳于哪棰平台雉行付款∶使用手檄平台付款的盯髑组合畲昊如要取消盯开﹐睛根褫手橙作巢系统前往指定毁定夏面﹐亚按照指示取淌盯开∶使用搁站平台付款的盯髑组合自霓如要取消盯髑﹐可于Paypal眼卢的毅定取淌有嗣盯闟之付费﹔详情睛酪韵您的付款方式服移提供者·
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>3.4</p>
        <p className={styles.msg}>
          固闇幌巨·若要闟开帐后﹐可以直接鼋鄄至CS@hk正念.com或致鼋29928686舆客卢服鸦主任睇胳﹐我阴将有毒人直接蒍你服务。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>3.5</p>
        <p className={styles.msg}>
          变更价格与服务方桉。我们可随时变更服务方桉与价格；但任何价格或服务方桉变更要在通知您至少
          30 天后方能生效。
        </p>
      </p>
      <p className={styles.one}>4. 正念 服务</p>
      <p className={styles.two}>
        <p className={styles.msg}>4.1</p>
        <p className={styles.msg}>
          您必须年满 18
          岁或达到您所在区域、地区或国家的法定成年年龄，方可成为本服务的会员。未成年人须在成年人监督下使用本服务。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>4.2</p>
        <p className={styles.msg}>
          本服务及透过本服务所观赏的任何内容仅供个人使用，不可用于商业用途。在您的
          正念
          会员资格有效期间内，我们授予您有限、非专属、不得转让的权利以使用本服务使用权并观赏
          正念
          内容。除上述有限许可外，我们不向您转让任何权利、所有权或利益。您同意不使用本服务进行公开播放。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>4.3</p>
        <p className={styles.msg}>
          您主要可透过您的帐户所在国家或地区观看本服务，而且只能在我们有提供服务并授权此类内容之地区观赏。可提供观赏的内容因地域而异，且随时变更。您可同时观赏的装置数目取决于您所选择的订阅方桉，详情请见您的[订阅组合]页面(方法请参阅本服务条款第1条)。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>4.4</p>
        <p className={styles.msg}>
          您同意根据所有适用法律、规则和规范或针对此服务或内容的其他使用限制规定使用本服务，包括与其相关的所有特色和功能。您同意不存档、複製、散布、修改、展示、公开播放、出版、授权、製作衍生作品、出售或使用（除非本《服务条款》明确授权）本服务所含的内容和资讯或从本服务取得的内容和资讯。您还同意不：规避、移除、更改、停用、降级或妨碍本服务的任何内容保护措施；使用任何网路机器人(robot)、网路蜘蛛
          (spider)、scraper程式或其他自动方式来使用本服务；反编译、逆向工程或解译透过本服务取得的任何软体或其他产品或程式；插入任何程式码或产品或以任何方式操控本服务的内容；或使用任何资料探勘、资料收集或资料撷取方法。此外，您同意不上传、发布、以电邮传送或以其他方式发送或传输任何旨在干扰、破坏或限制与本服务相关的任何电脑软体或硬体或电信设备功能的资料，包括任何软体病毒或其他任何电脑程式码、档桉或程式。如果您违反本《服务条款》或参与非法或诈欺使用本服务，则我们可终止或限制您使用本服务。{' '}
        </p>
      </p>
      <p className={styles.one}>5. 网站内容</p>
      <p className={styles.two}>
        <p className={styles.msg}>5.1</p>
        <p className={styles.msg}>
          「原状」及属「原供应」状态。于适用法律允许的最大范围内，我们不会对所提供的内容作任何形式的陈述或保证（暗示或明示），同时该等内容不应作为特定的商业、金融、业务或法律意见。您仅能以本服务特意提供的功能及本服务条款所允许的情况下连接正念内容供您作参考及个人的、非商业用途。除非有明确授权，我们及相关的内容提供者保留所有本服务及内容的权利。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>5.2</p>
        <p className={styles.msg}>
          您明白当您使用本服务时，您可能会接触到不同来源的正念内容，而我们不会就该等内容的準确性、用处、安全性，或其知识产权负责。您进一步明白及确认，当您使用本服务时，您可能会接触到不準确、您认爲具冒犯性、不雅、或令您反感的正念内容。就该等内容，您同意放弃，并谨此放弃向我们提出任何（不论是法律上或衡平法上）的申索或寻求补偿的权利。于适用法律允许的最大范围内，您同意弥偿我们，并保护我们免受任何基于或有关您使用本服务所引致我们蒙受的一切任何由第叁方提出的索偿、费用或要求。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>5.3</p>
        <p className={styles.msg}>
          在本协议及/或您就本服务之使用终止或届满的情况下，此第5项条款仍继续有效。
        </p>
      </p>
      <p className={styles.one}>6. 知识产权</p>
      <p className={styles.two}>
        <p className={styles.msg}>6.1</p>
        <p className={styles.msg}>
          您同意我们拥有并保留本服务及/或正念内容的所有权，我们及内容的提供者拥有及保留对相关内容的所有权利。所有于本服务、正念内容及/或正念平台内的商标、服务标示及标志（“标志”）均属我们拥有，或我们获得授权使用。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>6.2</p>
        <p className={styles.msg}>
          您确认本服务、正念内容及/或标志受到版权、商标法及其他知识产权法律所保护。您进一步同意，除您提供的内容外，您被授予的是非独家、不可转让及有限度的授权（没有转授权），连接及使用本服务及/或正念内容；并且，您会遵守本协议的条款只以串流方式连接及使用本服务及/或正念内容。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>6.3</p>
        <p className={styles.msg}>
          除非我们另有明确说明及除您提供的内容外，就您于或有关于本服务、正念内容，及当中所载的材料进行的活动，都不会致使任何知识产权转让予您，也不会授权您行使任何知识产权的权利。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>6.4</p>
        <p className={styles.msg}>
          倘若您侵犯任何我们的知识产权或任何人士的其他权利，我们明确保留向您采取行动的权利。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>6.5</p>
        <p className={styles.msg}>
          在本协议及/或您就本服务之使用终止或届满的情况下，此第6项条款仍继续有效。
        </p>
      </p>
      <p className={styles.one}>7. 密码与帐户存取</p>

      <p className={styles.msg}>
        建立 正念 帐户且其付款方式已完成扣款的会员（「帐户所有人」）可存取并控制
        正念 帐户以及用以存取本服务的 正念
        相容装置。为保持对帐户的控制并防止任何人存取帐户（包括帐户的观赏记录的资讯），帐户所有人应掌握
        正念
        相容装置之控制权，不得将其帐户的密码或付款方式的详细资料洩漏给任何人。对于您向我们提供的帐户相关资讯，您有责任更新并保持其準确性。我们可能会终止或暂停您的帐户，以便保护您、正念
        或合作伙伴免受身份盗窃或其他诈欺活动的损害。
      </p>
      <p className={styles.one}>8. 担保与责任限制</p>
      <p className={styles.msg}>
        本服务是以「现状」提供，不提供任何保固或条件。特别是，本服务不可能不受到干扰或不会出现错误。您同意放弃对我们请求任何特殊、间接及衍生性的损害赔偿。这些条款不限制您依据居住国家/地区法律所享有的任何不可放弃的保证或消费者保护权。
      </p>
      <p className={styles.one}>9. 免责声明</p>
      <p className={styles.two}>
        <p className={styles.msg}>9.1</p>
        <p className={styles.msg}>
          在任何正念平台上的任何视频、数据、文章、至第叁方平台之连结和其他资料（统称「资料」）皆以「现况」形式提供，并只作提供资讯之用。
        </p>
      </p>
      <p className={styles.two}>
        <p className={styles.msg}>9.2</p>
        <p className={styles.msg}>阁下使用正念平台，即视为知悉和同意：</p>
        <img src={require('./image/6.png').default} />
      </p>
      <img src={require('./image/10.png').default} />
      <img src={require('./image/11.png').default} />
      <img src={require('./image/w.png').default} />
    </div>
  );
}
